import { combineReducers } from 'redux'
import { customerReducer } from './customer/reducer'
import loginReducer from './example/example.reducer'
import common from './common/common.reducer'
import userReducer from './user/reducer'
import bannerReducer from './banner/reducer'
import uploadReducer from './upload/reducer'
import couponReducer from './coupon/reducer'
import merchantsReducer from './merchants/reducer'
import uomReducer from './uom/reducer'
import manufactuerReducer from './manufactuer/reducer'
import categoriesReducer from './categories/reducer'
import productReducer from './product/reducer'
import deliveryCostReducer from './delivery-cost/reducer'
import orderReducer from './orders/reducer'
import dashboarcReducer from './dashboard/reducer'
import posReducer from './pos/reducer'
import posMornitoringReducer from './pos-mornitoring/reducer'
import advertiseReducer from './advertise/reducer'
import manangeUserReducer from './manage-user/reducer'
import supplierReducer from './supplier/reducer'
import SaleOrderCustomerReducer from './saleorder-customer/reducer'
import purchaseReducer from './purchase/reducer'
import grnReducer from './grn/reducer'
import configReducer from './config/reducer'
import paymentReducer from './grn-payment/reducer'
import stockReducer from './stock/reducer'
import quotationReducer from './quotation/reducer'
import pointReducer from './point/reducer'
import taxReducer from './tax-management/reducer'
import supplierOrderReducer from './supplier-order/reducer'
import supplierInvoiveReducer from './supplier-invoice/reducer'
import miniRmxReducer from './minirmx-dashboard/reducer'
import supplierBillReducer from './supplier-bill/reducer'
import returnOrderReducer from './return-order/reducer'
import manageRoleReducer from './manage-role/reducer'
import managePermissionReducer from './manage-permission/reducer'
import manageRolePermissionReducer from './manage-role-permission/reducer'
import manageContentReducer from './manage-content/reducer'
import manageRolePackageReducer from './manage-role-package/reducer'
import manageMerchantTypeReducer from './manage-merchant-type/reducer'
import memberPointReducer from './member-point/reducer'
import memberRewardReducer from './member-reward/reducer'

const rootReducer = combineReducers({
  customer: customerReducer,
  loginReducer,
  common,
  userReducer,
  bannerReducer,
  uploadReducer,
  couponReducer,
  merchantsReducer,
  uomReducer,
  manufactuerReducer,
  categoriesReducer,
  productReducer,
  deliveryCostReducer,
  orderReducer,
  dashboarcReducer,
  posReducer,
  posMornitoringReducer,
  advertiseReducer,
  manangeUserReducer,
  supplierReducer,
  purchaseReducer,
  grnReducer,
  configReducer,
  paymentReducer,
  stockReducer,
  quotationReducer,
  pointReducer,
  taxReducer,
  supplierOrderReducer,
  supplierInvoiveReducer,
  miniRmxReducer,
  SaleOrderCustomerReducer,
  supplierBillReducer,
  returnOrderReducer,

  //manage permission
  manageRoleReducer,
  managePermissionReducer,
  manageRolePermissionReducer,
  manageRolePackageReducer,
  manageMerchantTypeReducer,

  manageContentReducer,

  memberPointReducer,
  memberRewardReducer,
})

export default rootReducer
